// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ChargeTriggerType } from '@/constants/charge-trigger-type';
import {
  BoltOutlined,
  FlagOutlined,
  ScheduleOutlined,
} from '@/constants/hardfin-standard-icons';
import { ReactElement } from 'react';

interface TriggerTypeDescriptor {
  icon: ReactElement;
  // Short label for chips, filter menus, and legends.
  label: string;
  // Long-form tooltip copy explaining what the trigger means for billing.
  description: string;
}

export const CHARGE_TRIGGER_TYPE_DESCRIPTORS: Record<
  ChargeTriggerType,
  TriggerTypeDescriptor
> = {
  TIME: {
    icon: <ScheduleOutlined fontSize="small" />,
    label: 'Time',
    description:
      'Auto-bills when the expected billable date passes — no manual action needed',
  },
  MANUAL: {
    icon: <FlagOutlined fontSize="small" />,
    label: 'Milestone',
    description:
      'Requires manual confirmation — someone must mark the milestone billable',
  },
  EVENT: {
    icon: <BoltOutlined fontSize="small" />,
    label: 'Event',
    description:
      'Auto-bills when a downstream event fires (e.g., asset ships, contract signs)',
  },
};

// Stable display order for filter menus and legends. Time first (the most
// common), then the two non-time policies grouped together.
export const CHARGE_TRIGGER_TYPE_ORDER: ChargeTriggerType[] = [
  'TIME',
  'MANUAL',
  'EVENT',
];
